import { render, staticRenderFns } from "./ShipsPiAccidentIncidentDelay24Hrs.vue?vue&type=template&id=775aa855&scoped=true&"
import script from "./ShipsPiAccidentIncidentDelay24Hrs.vue?vue&type=script&lang=js&"
export * from "./ShipsPiAccidentIncidentDelay24Hrs.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiAccidentIncidentDelay24Hrs.vue?vue&type=style&index=0&id=775aa855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775aa855",
  null
  
)

export default component.exports